module.exports = __webpack_public_path__ + "media/images/smart_phone/icons/my_print-6fe9499521fc8024807ba24b89fc1529.png";